import { render, staticRenderFns } from "./CreateBrandMonitoring.vue?vue&type=template&id=c2addcbe&scoped=true&"
import script from "./CreateBrandMonitoring.vue?vue&type=script&lang=ts&"
export * from "./CreateBrandMonitoring.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBrandMonitoring.vue?vue&type=style&index=0&id=c2addcbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2addcbe",
  null
  
)

export default component.exports